





















































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common";
import moment from 'moment';
import jsZip from "jszip";
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import SaitenBox from "../../components/SaitenBox.vue";
import RecogSidebar from "../../components/RecogSidebar.vue";
import { BModal, BCarousel, BPopover } from 'bootstrap-vue';
import axios, { CancelTokenSource } from 'axios';
import { Sheet, SheetField, SheetActivity, FieldActivity, ParamFieldActivity, SaitenModeEnum, CorrectStateEnum, SortKindEnum } from "../../modules/teacher/SaitenInput";

export interface Data {
  sheet_id: string
  sheet_field_id: string
  next_room_sheet_id: number | null
  next_room_sheet_field: SheetField | null
  prev_room_sheet_id: number | null
  prev_room_sheet_field: SheetField | null
  prev_sheet_field: SheetField | null
  next_sheet_field: SheetField | null
  currentSheet: Sheet | null
  currentSheetField: SheetField | null
  fieldActivities: FieldActivity[]
  selectedIdx: number
  colCount: number
  scale: number
  fieldPadding: number
  fieldMargin: number
  fieldWrapWidth: number
  fieldWrapHeight: number
  fieldImageWidth: number
  fieldImageHeight: number
  windowHeight: number
  SaitenModeEnum: Readonly<{None: number; KeyInput: number; SeitouClick: number; GotouClick: number; TokutenClick: number; 
                            FreeLine: number; StraightLine: number; BracesStart: number; BracesEnd: number; Number: number; Eraser: number; TextStamp: number;}>
  CorrectStateEnum: Readonly<{Seitou: number; Gotou: number; Tokuten: number}>
  SortKindEnum: Readonly<{No: number; CorrectState: number; FileSize: number}>
  saitenMode: number
  sortKind: number
  scoreOptions: any[]
  selectedScore: number
  isTokutenModeDisabled: boolean
  processingTime: number
  base64CorrectImage: string
  tensakuText: string
  tensakuFontSize: number
  stampText: string
  stampFontSize: number
  isStampVertical: boolean
  thickness: number
  isColCountChanged: boolean
  isWindowEventAdded: boolean
  allowResetSaitenLock: boolean
  isShortcutKeyEnable: boolean
  isUpdateConfirmed: boolean
  tensakuNumberOptions: any[]
  fontSizeOptions: any[]
  pcHelpFields: any[]
  tabletHelpFields: any[]
  carouselPageIdx: number
  modalIdx: number
  timer: any
  errors: string[]
  isRecogSidebarVisible: boolean
  isRecogOverlay: boolean
  cancelToken: CancelTokenSource
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "saiten-box": SaitenBox,
    "recog-sidebar": RecogSidebar,
  },
  setup(props, context){

    const saitenBoxRef = ref([]);
    const modalCorrectImageRef = ref<InstanceType<typeof BModal>>();
    const modalAddtionRef = ref<InstanceType<typeof BModal>>();
    const modalPcHelpRef = ref<InstanceType<typeof BModal>>();
    const modalTabletHelpRef = ref<InstanceType<typeof BModal>>();
    const modalPreviewImageRef = ref<InstanceType<typeof BModal>>();
    const popoverNumTextRef = ref<InstanceType<typeof BPopover>>();
    const popoverTextStampRef = ref<InstanceType<typeof BPopover>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();
    const recogSidebarRef = ref<InstanceType<typeof RecogSidebar>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet_field_id: "",
      next_room_sheet_id: null,
      next_room_sheet_field: null,
      prev_room_sheet_id: null,
      prev_room_sheet_field: null,
      prev_sheet_field: null,
      next_sheet_field: null,
      currentSheet: null,
      currentSheetField: null,
      fieldActivities: null,
      selectedIdx: 0,
      colCount: 0,
      scale: 0,
      fieldPadding: 8,
      fieldMargin: 5,
      fieldWrapWidth: 0,
      fieldWrapHeight: 0,
      fieldImageWidth: 0,
      fieldImageHeight: 0,
      windowHeight: 0,
      SaitenModeEnum: SaitenModeEnum,
      CorrectStateEnum: CorrectStateEnum,
      SortKindEnum: SortKindEnum,
      saitenMode: SaitenModeEnum.KeyInput,
      sortKind: SortKindEnum.No,
      scoreOptions: new Array<object>(),
      selectedScore: 0,
      isTokutenModeDisabled: false,
      processingTime: 0,
      base64CorrectImage: "",
      tensakuText: "1",
      tensakuFontSize: 30,
      stampText: "",
      stampFontSize: 30,
      isStampVertical: false,
      thickness: 2,
      isColCountChanged: false,
      isWindowEventAdded: false,
      isUpdateConfirmed: false,
      allowResetSaitenLock: true,
      isShortcutKeyEnable: false,
      tensakuNumberOptions: new Array<object>(),
      fontSizeOptions: new Array<object>(),
      pcHelpFields: [
        { key: "Oキー", img: require("@/assets/images/keyboard_O.png"), description: "正答○（KEY入力モードのみ有効）" },
        { key: "Xキー", img: require("@/assets/images/keyboard_X.png"), description: "誤答✕（KEY入力モードのみ有効）" },
        { key: "1-9キー", img: require("@/assets/images/keyboard_1.png"), description: "△得点（KEY入力モードのみ有効）" },
        { key: "Pキー", img: require("@/assets/images/keyboard_P.png"), description: "一括正答（未採点分をすべて○）" },
        { key: "Zキー", img: require("@/assets/images/keyboard_Z.png"), description: "一括誤答（未採点分をすべて✕）" },
        { key: "エンターキー", img: require("@/assets/images/keyboard_Enter.png"), description: "採点内容を保存して次の設問へ、または次の教室へ移動" },
        { key: "Wキー", img: require("@/assets/images/keyboard_W.png"), description: "模範解答画像を表示" },
        { key: "矢印キー", img: require("@/assets/images/keyboard_Arrow.png"), description: "矢印の方向の切出し画像へ選択を変更" },
      ],
      tabletHelpFields: [
        { key: "右方向", img: require("@/assets/images/flick_right.png"), description: "正答○" },
        { key: "左方向", img: require("@/assets/images/flick_left.png"), description: "誤答✕" },
        { key: "下方向", img: require("@/assets/images/flick_down.png"), description: "△の横の得点" },

      ],
      carouselPageIdx: 0,
      modalIdx: 0,
      timer: null,
      errors: [],
      isRecogSidebarVisible: false,
      isRecogOverlay: false,
      cancelToken: null,
    });

    /************************************************************
     * モーダル表示対象の答案画像
     ************************************************************/

    const base64PreviewImages = computed((): any => {
      return state.fieldActivities[state.modalIdx].base64PreviewImages;
    });

    /************************************************************
     * ボタンからフォーカス解除
     ************************************************************/
    const blur = () => {
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
    }

    /************************************************************
     * 画面のレイアウト整形
     * 初期表示・ウィンドウリサイズ・拡大縮小ボタン押下時に発動
     ************************************************************/

    const adjustLayout = () => {
      const windowHeight = window.innerHeight;
      const imageArea = document.getElementById("image-area");
      const footerArea = document.getElementById("footer-area");
      const footerBorder = document.getElementById("footer-border");
      state.windowHeight = windowHeight;
      
      // 画像表示エリアの高さを画面サイズに合わせる
      if(imageArea != null && footerArea != null){
        imageArea.style.height = (windowHeight - imageArea.offsetTop - footerArea.clientHeight - footerBorder.offsetHeight) + "px";
      }
      
      // 画像1件あたりの縦横サイズを整形
      state.fieldWrapWidth = imageArea.clientWidth / state.colCount - (state.fieldMargin * 2);
      state.fieldImageWidth = state.fieldWrapWidth - (state.fieldPadding * 2);
      state.scale = state.fieldImageWidth / (state.currentSheetField.baseWidth);
      state.fieldImageHeight = Math.round((state.currentSheetField.baseHeight) * state.scale);
      state.fieldWrapHeight = state.fieldImageHeight + state.fieldPadding * 2;
    };

    /************************************************************
     * 模範解答モーダル表示
     ************************************************************/

    const showModalCorrectImage = () => {
      blur();
      modalCorrectImageRef.value.show();
    };

    /************************************************************
     * メモモーダル表示
     ************************************************************/

    const showModalMemo = () => {
      blur();
      modalAddtionRef.value.show();
    };

    /************************************************************
     * PC用ヘルプモーダル表示
     ************************************************************/

    const showModalPcHelp = () => {
      blur();
      modalPcHelpRef.value.show();
    };

    /************************************************************
     * タブレット用ヘルプモーダル表示
     ************************************************************/

    const showModalTabletHelp = () => {
      blur();
      modalTabletHelpRef.value.show();
    };

    /************************************************************
     * 全体画像モーダル表示
     ************************************************************/

    const showPreviewImage = async (idx: number) => {
      blur();
      state.modalIdx = idx;

      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      state.carouselPageIdx = 0;
      modalPreviewImageRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 答案画像モーダル用画像ダウンロード
     ************************************************************/

    const downloadImage = async () => {
      let isSuccess = true;
      context.root.$store.dispatch("showOverlay");
      const student_id = state.fieldActivities[state.modalIdx].sheetActivity.student_id;
      await http.get(`/api/saiten_input/download_preview_image/${state.sheet_id}/${student_id}/${state.carouselPageIdx + 1}`).then(response => {
        response.data.base64_images.forEach((x: string) => {
          state.fieldActivities[state.modalIdx].base64PreviewImages.push(x);
        });
      })
      .catch(error=>{
        isSuccess = false;
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      return isSuccess;
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/

    const carouselPrev = async () => {
      // carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.currentSheet.page_count - 1;
      }

      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/

    const carouselNext = async () => {
      // carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.currentSheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }

      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevModalStudent = async () => {
      
      if(state.modalIdx > 0){
        state.modalIdx--;
      }else{
        state.modalIdx = state.fieldActivities.length - 1;
      }

      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      // state.carouselPageIdx = 0;
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextModalStudent = async () => {
      if(state.modalIdx + 1 < state.fieldActivities.length){
        state.modalIdx++;
      }else{
        state.modalIdx = 0;
      }
      
      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      // state.carouselPageIdx = 0;
      // modalPreviewImageRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 並び順切り替え
     ************************************************************/

    const changeSortKind = (sortKind: number) => {
      blur();
      state.sortKind = sortKind;
      
      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });

      if(sortKind == state.SortKindEnum.No){
        state.fieldActivities.sort((a, b) => a.sheetActivity.student_id - b.sheetActivity.student_id);
      }else if(sortKind == state.SortKindEnum.CorrectState){
        state.fieldActivities.sort((a, b) => {
          if(a.score != b.score){
            return (a.score - b.score) * -1;
          }
          return a.sheetActivity.student_id - b.sheetActivity.student_id;
        });
      }else{
        state.fieldActivities.sort((a, b) => {
          if(a.base64Image.length != b.base64Image.length){
            return (a.base64Image.length - b.base64Image.length) * -1;
          }
          return a.sheetActivity.student_id - b.sheetActivity.student_id;
        });
      }
    };

    /************************************************************
     * 拡大・縮小
     ************************************************************/

    const changeColCount = (addValue: number) => {
      blur();
      if(state.colCount + addValue <= 0){
        return;
      }

      state.colCount += addValue;
      state.isColCountChanged = true;
      adjustLayout();
    }

    /************************************************************
     * 採点モード切り替え
     ************************************************************/

    const changeSaitenMode = (saitenMode: number) => {
      blur();
      if(state.saitenMode == saitenMode){
        state.saitenMode = state.SaitenModeEnum.None;
      }else{
        state.saitenMode = saitenMode;
      }

      popoverNumTextRef.value.$emit("close");
      popoverTextStampRef.value.$emit("close");

      if(state.saitenMode == state.SaitenModeEnum.Number){
        popoverNumTextRef.value.$emit("open");
      }else if(state.saitenMode == state.SaitenModeEnum.TextStamp){
        popoverTextStampRef.value.$emit("open");
      }
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

    const keyUp = (e: KeyboardEvent) => {

      // API通信中は処理しない
      if(!state.isShortcutKeyEnable){
        return;
      }

      // 認識サイドバー表示中は模範解答表示以外は処理しない
      if(state.isRecogSidebarVisible){
        if(e.key == "w" && !context.root.$store.getters.isHomework){
          recogSidebarRef.value.isDispCorrectImage = !recogSidebarRef.value.isDispCorrectImage;
        }
        return;
      }

      // メモのtextareaがフォーカスされている場合は処理しない
      if(document.activeElement.nodeName.toLowerCase() == "textarea"){
        return;
      }

      e.preventDefault();

      if(["o", "x", "y", "1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(e.key) != -1){
        
        // キー入力モード以外は処理しない
        if(state.saitenMode != state.SaitenModeEnum.KeyInput){
          return;
        }

        if(e.key == "o"){
          // Oキー 正答
          setCorrect(state.CorrectStateEnum.Seitou, state.currentSheetField.allot);
        }else if(e.key == "x"){
          // Xキー 誤答
          setCorrect(state.CorrectStateEnum.Gotou, 0);
        }else if(e.key == "y"){
          // Yキー 部分点 部分点入力不可の場合は処理終了
          if(state.isTokutenModeDisabled){
            return;
          }
          setCorrect(state.CorrectStateEnum.Tokuten, state.selectedScore);
        }else if(["1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(e.key) != -1){
          // 数字キー1〜9押下で部分点
          const score = Number(e.key);
          if(score < state.currentSheetField.allot){
            setCorrect(state.CorrectStateEnum.Tokuten, score);
          }else{
            // 部分点が配点の範囲外の場合は処理終了
            return;
          }
        }

        if(state.selectedIdx + 1 == state.fieldActivities.length){
          if(state.fieldActivities.filter(x => x.correct_state == null).length == 0){
            setTimeout(() => {
              // 次の設問 又は 次の教室へ
              if(state.next_sheet_field != null){
                toNextField();
              }else if(window.confirm("最後の設問を採点しました。一覧へ移動します。よろしいですか？")){
                sendSaitenData(null, null);
              }
            }, 100);
          }
        }else{
          state.selectedIdx++;
          const prevSaitenBox = document.getElementById(`saiten-box-${state.selectedIdx - 1}`);
          const nextSaitenBox = document.getElementById(`saiten-box-${state.selectedIdx}`);
          if(prevSaitenBox.offsetTop != nextSaitenBox.offsetTop){
            const imageArea = document.getElementById("image-area");
            const fromPos = imageArea.scrollTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop);
            const toPos = nextSaitenBox.offsetTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop) - imageArea.offsetTop;
            Common.smoothScroll(fromPos, toPos, imageArea);
          }
        }
      }else if(e.key == "Enter"){
        // エンターキー モーダル用時中の場合はモーダルを閉じる それ以外は後続処理で次の設問へ画面遷移
        if(modalCorrectImageRef.value.$data.isShow){
          modalCorrectImageRef.value.hide();
        }else if(modalAddtionRef.value.$data.isShow){
          modalAddtionRef.value.hide();
        }else{
          // 次の設問へ
          if(state.next_sheet_field != null){
            toNextField();
          }else if(window.confirm("最後の設問を採点しました。一覧へ移動します。よろしいですか？")){
            sendSaitenData(null, null);
          }
        }
      }else if(["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].indexOf(e.key) != -1){
        
        const nowIdx = state.selectedIdx;
        let nextIdx = -1;

        if(e.key == "ArrowLeft"){
          // 左矢印 前の設問へ
          nextIdx = state.selectedIdx - 1;
        }else if(e.key == "ArrowRight"){
          // 右矢印 次の設問へ
          nextIdx =  state.selectedIdx + 1;
        }else{
          const row = Math.floor(state.selectedIdx / state.colCount);
          const col = state.selectedIdx % state.colCount;
          if(e.key == "ArrowUp"){
            // 上矢印 上の行の設問へ
            nextIdx = ((row - 1) * state.colCount) + col;
          }else if(e.key == "ArrowDown"){
            // 下矢印 下の行の設問へ
            nextIdx = ((row + 1) * state.colCount) + col;
          }
        }

        // インデックスが範囲外の場合は処理終了
        if(nextIdx < 0 || nextIdx + 1 > state.fieldActivities.length){
          return;
        }

        state.selectedIdx = nextIdx;
        const nowSaitenBox = document.getElementById(`saiten-box-${nowIdx}`);
        const nextSaitenBox = document.getElementById(`saiten-box-${nextIdx}`);
        if(nowSaitenBox.offsetTop != nextSaitenBox.offsetTop){
          const imageArea = document.getElementById("image-area");
          const fromPos = imageArea.scrollTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop);
          const toPos = nextSaitenBox.offsetTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop) - imageArea.offsetTop;
          Common.smoothScroll(fromPos, toPos, imageArea);
        }

      }else if(e.key == "w"){
        // Wキー 模範解答モーダル表示
        modalCorrectImageRef.value.show();
      }else if(e.key == "p"){
        // Pキー 一括正答採点
        allCorrectChange(CorrectStateEnum.Seitou);
      }else if(e.key == "z"){
        // Zキー 一括誤答採点
        allCorrectChange(CorrectStateEnum.Gotou);
      }
    };

    /************************************************************
     * 採点内容変更
     ************************************************************/

    const setCorrect = (correctState: number, score: number) => {

      const fieldActivity = state.fieldActivities[state.selectedIdx];
      fieldActivity.correct_state = correctState;
      fieldActivity.score = score;
    }

    /************************************************************
     * 一括採点ボタン押下
     ************************************************************/

    const allCorrectChange = (correctState: number) => {

      blur();

      if(!window.confirm("未採点項目の採点内容を一括で変更します。よろしいですか？")){
        return;
      }

      state.fieldActivities.filter(x => x.correct_state == null).forEach(x => {
        x.correct_state = correctState;
        if(correctState == state.CorrectStateEnum.Seitou){
          x.score = state.currentSheetField.allot;
        }else{ 
          x.score = 0;
        }
      });
    };

    /************************************************************
     * CLEARボタン押下
     ************************************************************/

    const clearCorrect = async () => {
      blur();

      if(!window.confirm("画面に表示されている採点内容のデータを削除します。よろしいですか？")){
        return;
      }

      // パラメータ用FieldActivities
      const paramFieldActivities = new Array<ParamFieldActivity>();
      state.fieldActivities.forEach(x => {
        paramFieldActivities.push(new ParamFieldActivity(x));
      });

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/saiten_input/clear_correct/${state.sheet_field_id}`, {field_activities: JSON.stringify(paramFieldActivities)}).then(response => {
        alert(`採点内容のクリアに成功しました。`);
        window.location.reload();
      })
      .catch(error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 採点一覧へ遷移
     ************************************************************/

    const toSaitenList = () => {
      context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
    };

    /************************************************************
     * 保存して採点一覧へ遷移
     ************************************************************/

    const toSaitenListWithSendSaitenData = () => {
      blur();

      if(!confirmUncompletedField() || !window.confirm("採点内容を保存して採点一覧に戻ります。よろしいですか？")){
        return;
      }

      sendSaitenData(null, null);
    };

    /************************************************************
     * 前の設問へ遷移
     ************************************************************/

    const toPrevField = () => {
      blur();

      if(!confirmUncompletedField() || !window.confirm("前の設問へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(Number(state.sheet_id), state.prev_sheet_field);
    };

    /************************************************************
     * 次の設問へ遷移
     ************************************************************/

    const toNextField = async () => {
      blur();

      if(!confirmUncompletedField() || !window.confirm("次の設問へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(Number(state.sheet_id), state.next_sheet_field);
    };

    /************************************************************
     * 次の教室へ遷移
     ************************************************************/

    const toNextSheet = () => {
      blur();

      if(!confirmUncompletedField() || !window.confirm("次の教室へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(state.next_room_sheet_id, state.next_room_sheet_field);
    };

    /************************************************************
     * 前の教室へ遷移
     ************************************************************/

    const toPrevSheet = () => {
      blur();

      if(!confirmUncompletedField() || !window.confirm("前の教室へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(state.prev_room_sheet_id, state.prev_room_sheet_field);
    };

    /************************************************************
     * 未採点有無の確認
     ************************************************************/

    const confirmUncompletedField = () => {
      const isExistsUncompletedField = state.fieldActivities.filter(x => x.correct_state == null).length > 0;
      if(isExistsUncompletedField && !window.confirm("未採点があります。よろしいですか？")){
        return false;
      }else{
        return true;
      }
    };

    /************************************************************
     * メモ更新API
     ************************************************************/

    const updateAddition = async () => {
      if(!window.confirm("メモを更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/saiten_input/update_addition/${state.sheet_field_id}`, {addition: state.currentSheetField.addition}).then(async response => {
        modalAddtionRef.value.hide();
      })
      .catch(error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 採点データ保存API
     ************************************************************/

    const sendSaitenData = async (next_sheet_id: number, next_sheet_field: SheetField) => {

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });
      
      // 添削画像をZip化
      let zip = new jsZip();
      state.fieldActivities.forEach(x => {
        if(x.isCanvasEdited){
          zip.file(`${x.id}_tensaku.png`, x.base64Canvas, {base64: true});
        }
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        // パラメータ用FieldActivities
        const paramFieldActivities = new Array<ParamFieldActivity>();
        state.fieldActivities.forEach(x => {
          paramFieldActivities.push(new ParamFieldActivity(x));
        });

        // 採点内容 or Canvasに変更が生じたsheet_acrivity_id
        const correctUpdatedIds = state.fieldActivities.filter(x => x.correct_state != x.correct_state_cache || x.score != x.score_cache).map(x => x.id);
        const canvasUpdatedIds = state.fieldActivities.filter(x => x.isCanvasEdited).map(x => x.id);

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("field_activities", JSON.stringify(paramFieldActivities));
        fd.append("processing_time", `${state.processingTime}`);
        fd.append("sheet_field_id", state.sheet_field_id);
        fd.append("correct_updated_ids", JSON.stringify(correctUpdatedIds));
        fd.append("canvas_updated_ids", JSON.stringify(canvasUpdatedIds));

        await http.patch(`/api/saiten_input/${state.sheet_id}`, fd).then(async response => {
          if(next_sheet_id != null){
            if(next_sheet_field.scoring_type == Common.ScoringTypeEnum.Seigo){
              // 正誤採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input/${next_sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(err => {});
              context.root.$nextTick(() => {
                initialize();
              });
            }else{
              // 得点スタンプ採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input_score_stamp/${next_sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(err => {});
            }
          }else{
            // 採点一覧へ戻る
            context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
          }
        })
        .catch(error=>{
          context.root.$store.dispatch("hideOverlay");
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });
    };

    /************************************************************
     * 排他制御解除して別設問へ移動するAPI
     ************************************************************/
    const changeFieldWithResetLastScored = async (toUrl: string) => {

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      await http.post(`/api/saiten_input/reset_last_scored/${state.sheet_field_id}`).then(response => {
        context.root.$router.push(toUrl).catch(err => {});
        if(toUrl.indexOf("saiten_input") != -1){
          context.root.$nextTick(() => {
            initialize();
          });
        }
      })
      .catch(error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * 初期表示データ取得API
     ************************************************************/

    const initialize = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      state.sheet_field_id = context.root.$route.params.sheet_field_id;

      if(state.timer != null){
        clearInterval(state.timer);
      }

      let confirmMessage = null;
      let browsableSheetErrMessage = null;
      await http.get(`/api/saiten_input/check_saiten_lock/${state.sheet_field_id}`).then(response => {
        confirmMessage = response.data.confirm_message;
        browsableSheetErrMessage = response.data.browse_lock_err_message;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      if (browsableSheetErrMessage != null) {
        alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${browsableSheetErrMessage}`);
        context.root.$router.push(`/teacher_site/sheet_list/`).catch(err => {});
        return;
      }

      // 他者排他制御中の場合は確認メッセージ
      if(confirmMessage != null){
        if(!window.confirm(confirmMessage)){
          state.allowResetSaitenLock = false;
          toSaitenList();
          return;
        }
      }

      await http.get(`/api/saiten_input?sheet_id=${state.sheet_id}&sheet_field_id=${state.sheet_field_id}`).then(response => {

        browsableSheetErrMessage = response.data.browse_lock_err_message;
        if (browsableSheetErrMessage != null) {
          return;
        }

        state.currentSheet = new Sheet(response.data.current_sheet);
        state.currentSheetField = new SheetField(response.data.current_sheet_field, response.data.buff_size);        
        state.fieldActivities = response.data.field_activities.map((x: any) => new FieldActivity(x, response.data.sheet_activities, response.data.students, response.data.base64_image_hash_array, response.data.base64_canvas_hash_array, state.currentSheet.page_count));
        state.base64CorrectImage = response.data.base64_correct_image;
        state.next_room_sheet_id = response.data.next_room_sheet_id;
        state.next_room_sheet_field = response.data.next_room_sheet_field;
        state.prev_room_sheet_id = response.data.prev_room_sheet_id;
        state.prev_room_sheet_field = response.data.prev_room_sheet_field;
        state.prev_sheet_field = response.data.prev_sheet_field;
        state.next_sheet_field = response.data.next_sheet_field;
        state.selectedIdx = 0;
        state.processingTime = 0;
        state.carouselPageIdx = state.currentSheetField.page -1;

        // 部分点プルダウン生成
        state.scoreOptions = new Array<any>();
        for(let i = 1; i < state.currentSheetField.allot; i++){
          state.scoreOptions.push({value: i, text: `${i}点`});
        }

        // 部分点プルダウン初期選択値設定
        if(state.scoreOptions.length > 0 && state.currentSheetField.partial_scorable){
          state.selectedScore = state.scoreOptions[0].value;
          state.isTokutenModeDisabled = false;
        }else{
          // 部分点選択不可の場合はボタン・プルダウン非活性
          state.isTokutenModeDisabled = true;
          if(state.saitenMode == state.SaitenModeEnum.TokutenClick){
            state.saitenMode = state.SaitenModeEnum.KeyInput;
          }
        }

        // 数字入力プルダウン生成
        state.tensakuNumberOptions = new Array<any>();
        for(let i = -100; i < 101; i++){
          state.tensakuNumberOptions.push({value: i, text: `${i}`});
        }

        // フォントサイズプルダウン生成
        state.fontSizeOptions = new Array<any>();
        for(let i = 5; i < 101; i++){
          state.fontSizeOptions.push({value: i, text: i});
        }

        // １行あたりの画像表示数設定 横長：6画像 縦長：15画像
        if(!state.isColCountChanged){
          if(state.currentSheetField.baseWidth > state.currentSheetField.baseHeight){
            state.colCount = 6;
          }else{
            state.colCount = 15;
          }
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      if (browsableSheetErrMessage != null) {
        alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${browsableSheetErrMessage}`);
        context.root.$router.push(`/teacher_site/sheet_list/`).catch(err => {});
        return;
      }

      if(!state.isWindowEventAdded){
        window.addEventListener("keyup", keyUp);
        window.addEventListener("resize", adjustLayout);
        state.isWindowEventAdded = true;
      }
      adjustLayout();
      state.processingTime = 0;
      state.timer = setInterval(() => state.processingTime++, 1000);
      context.root.$nextTick(() => {
        modalCorrectImageRef.value.show();
      });

      context.root.$nextTick(() => {
        if(state.fieldActivities.filter(x => x.correct_state != null).length > 0){
          // 採点済みデータありの場合は○×順表示で表示
          changeSortKind(state.SortKindEnum.CorrectState);
        }else{
          // 全件未採点の場合は番号順で表示
          changeSortKind(state.SortKindEnum.No);
        }
      });

      const imageArea: HTMLElement = document.getElementById("image-area");
      imageArea.scrollTop = 0;

      // 認識コンポーネント初期化
      recogSidebarRef.value.initialize();

      state.isShortcutKeyEnable = true;
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 切り出し画像Base64文字列をセット
     ************************************************************/

    const setBase64Image = (idx: number, base64Image: string) => {
      state.fieldActivities[idx].base64Image = base64Image;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 添削画像Base64文字列をセット
     ************************************************************/

    const setBase64Canvas = (idx: number, base64Canvas: string) => {
      state.fieldActivities[idx].base64Canvas = base64Canvas;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * canvas編集フラグをセット
     ************************************************************/

    const setCanvasEdited = (idx: number) => {
      state.fieldActivities[idx].isCanvasEdited = true;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 設問の画像上をクリック
     ************************************************************/

    const fieldClicked = (idx: number) => {
      state.selectedIdx = idx;
      
      if(state.saitenMode == state.SaitenModeEnum.SeitouClick){
        setCorrect(state.CorrectStateEnum.Seitou, state.currentSheetField.allot);
      }else if(state.saitenMode == state.SaitenModeEnum.GotouClick){
        setCorrect(state.CorrectStateEnum.Gotou, 0);
      }else if(state.saitenMode == state.SaitenModeEnum.TokutenClick){
        setCorrect(state.CorrectStateEnum.Tokuten, state.selectedScore);
      }
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 設問の画像上フリックによる採点
     ************************************************************/
    
    const setCorrectByChild = (idx: number, correctState: number) => {
      state.selectedIdx = idx;
      
      if(correctState == state.CorrectStateEnum.Seitou){
        setCorrect(state.CorrectStateEnum.Seitou, state.currentSheetField.allot);
      }else if(correctState == state.CorrectStateEnum.Gotou){
        setCorrect(state.CorrectStateEnum.Gotou, 0);
      }else if(correctState == state.CorrectStateEnum.Tokuten && state.selectedScore > 0){
        setCorrect(state.CorrectStateEnum.Tokuten, state.selectedScore);
      }
    };

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      initialize();
    });

    /************************************************************
     * before unmount windowイベント解除・排他制御解除
     ************************************************************/
    onBeforeUnmount(async () => {
      
      // タイマー停止
      if(state.timer != null){
        clearInterval(state.timer);
      }
      
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("resize", adjustLayout);
      if(state.allowResetSaitenLock){
        await http.post(`/api/saiten_input/reset_last_scored/${state.sheet_field_id}`);
      }
    });

    /************************************************************
     * 文字認識サイドバー表示
     ************************************************************/

    const showRecogSidebar = (tabNo: number) => {
      recogSidebarRef.value.tabNo = tabNo;
      state.isRecogSidebarVisible = true;
    }

    /************************************************************
     * 文字認識実行
     ************************************************************/

     const recogExecute = async (param: any) => {
      state.isRecogOverlay = true;
      context.root.$store.dispatch("showOverlay");

      state.cancelToken = axios.CancelToken.source();

      await http.post(`/api/saiten_input/recog/${state.sheet_id}/${state.sheet_field_id}`, param, {
        cancelToken: state.cancelToken.token
      }).then(response => {
        let recog_correct_text = param["recog_correct_text"];
        
        if(param["is_recog_correct_image"] && response.data.correct_result != null){
          if(param["recog_type"] == Common.RecogTypeEnum.SingleAlpha){
            recog_correct_text = Common.getCorrectText(param["recog_type"], response.data.correct_result.recog_text);
          }else{
            recog_correct_text = response.data.correct_result.recog_text;
          }
          state.currentSheetField.recog_correct_text = recog_correct_text;
        }
        const results: any[] = response.data.results
        results.forEach(result => {
          const fieldActivity = state.fieldActivities.filter(x => x.id == result.field_activity_id)[0];
          fieldActivity.recog_text = result.recog_text;
          fieldActivity.confidence = result.confidence;
          fieldActivity.recog_errors = result.errors;

          // 正答が設定されている場合は正誤判定
          let correct_state: number = null;
          if(recog_correct_text != null){
            if(param["recog_type"] == Common.RecogTypeEnum.SingleAlpha){
              correct_state = recog_correct_text.includes(result.recog_text) ? state.CorrectStateEnum.Seitou : state.CorrectStateEnum.Gotou;;
            }else{
              correct_state = result.recog_text == recog_correct_text ? state.CorrectStateEnum.Seitou : state.CorrectStateEnum.Gotou;
            }
            const score = correct_state == state.CorrectStateEnum.Seitou ? state.currentSheetField.allot : 0;
            state.selectedIdx = state.fieldActivities.indexOf(fieldActivity);
            setCorrect(correct_state, score);
          }

          if(param["recog_type"] == Common.RecogTypeEnum.Math && result.recog_text != null){
            // 数式の場合はLaTexからSVGに変換
            fieldActivity.svgContent = Common.convertSvgElementByLaTex(result.recog_text);
          }else{
            fieldActivity.svgContent = null;
          }
        });

        // Common.showToast(context.root.$bvToast, "認識処理が完了しました。");
        state.isRecogSidebarVisible = false;
        changeSortKind(SortKindEnum.CorrectState)
      })
      .catch(error=>{
        state.isRecogOverlay = false;
        context.root.$store.dispatch("hideOverlay");
        if(axios.isCancel(error)){
          console.log(error);
        }else if(error.response && error.response.status == 422){
          recogSidebarRef.value.errors = error.response.data.errors;
        }else{
          recogSidebarRef.value.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      state.isRecogOverlay = false;
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 文字認識キャンセル
     ************************************************************/

     const recogCancel = () => {
      if(state.cancelToken){
        state.cancelToken.cancel('Operation canceled by the user.');
      }
    }

    /************************************************************
     * 編集した認識文字列で正誤判定
     ************************************************************/

    const recogByText = async (param: any) => {

      await http.post(`/api/saiten_input/update_recog_result/${state.sheet_id}/${state.sheet_field_id}`, param).then(response => {
        const selectedIdxCache = state.selectedIdx;
        for(const field_activity_id of param["param_field_activities"].map((x: any) => x["id"])){
          const fieldActivity = state.fieldActivities.filter(x => x.id == field_activity_id)[0];
          let correct_state: number = null;
          if(param["recog_correct_text"] != null){
            if(param["recog_type"] == Common.RecogTypeEnum.SingleAlpha){
              correct_state = param["recog_correct_text"].includes(fieldActivity.recog_text) ? Common.CorrectStateEnum.Seitou : Common.CorrectStateEnum.Gotou;
            }else{
              correct_state = fieldActivity.recog_text == param["recog_correct_text"] ? Common.CorrectStateEnum.Seitou : Common.CorrectStateEnum.Gotou;
            }
            const score = correct_state == Common.CorrectStateEnum.Seitou ? state.currentSheetField.allot : 0;
            state.selectedIdx = state.fieldActivities.indexOf(fieldActivity);
            setCorrect(correct_state, score);
          }

          if(state.currentSheetField.recog_type == Common.RecogTypeEnum.Math && fieldActivity.recog_text != null){
            // 数式の場合はLaTexからSVGに変換
            fieldActivity.svgContent = Common.convertSvgElementByLaTex(fieldActivity.recog_text);
          }else{
            fieldActivity.svgContent = null;
          }
        }
        state.selectedIdx = selectedIdxCache;
      })
      .catch(error=>{
        state.isRecogOverlay = false;
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          recogSidebarRef.value.errors = error.response.data.errors;
        }else{
          recogSidebarRef.value.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * 認識結果編集
     ************************************************************/

    const recogTextChanged = (field_activity_id: number, recog_text: string) => {
      const fieldActivity = state.fieldActivities.filter(x => x.id == field_activity_id)[0];
      fieldActivity.recog_text = recog_text;
      if(state.currentSheetField.recog_type == Common.RecogTypeEnum.Math && fieldActivity.recog_text){
        // 数式の場合はLaTexからSVGに変換
        fieldActivity.svgContent = Common.convertSvgElementByLaTex(fieldActivity.recog_text);
      }else{
        fieldActivity.svgContent = null;
      }
    }

    return {
      ...toRefs(state),
      saitenBoxRef,
      modalCorrectImageRef,
      modalAddtionRef,
      modalPcHelpRef,
      modalTabletHelpRef,
      modalPreviewImageRef,
      popoverNumTextRef,
      popoverTextStampRef,
      carouselRef,
      recogSidebarRef,
      changeColCount,
      setBase64Image,
      fieldClicked,
      showPreviewImage,
      setCorrectByChild,
      changeSaitenMode,
      changeSortKind,
      allCorrectChange,
      clearCorrect,
      setBase64Canvas,
      setCanvasEdited,
      focus,
      keyUp,
      showModalCorrectImage,
      showModalPcHelp,
      showModalTabletHelp,
      showModalMemo,
      toSaitenList,
      toPrevField,
      toNextField,
      toNextSheet,
      toPrevSheet,
      toSaitenListWithSendSaitenData,
      updateAddition,
      base64PreviewImages,
      carouselPrev,
      carouselNext,
      changePrevModalStudent,
      changeNextModalStudent,
      showRecogSidebar,
      recogExecute,
      recogCancel,
      recogByText,
      recogTextChanged,
    };
  }
});
